import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import distributionApi from 'services/api/distribution';
import { useSubscription } from 'services/hooks';
import { selectReleases } from 'services/store/distribution/selectors';

export const useGetIsUpsellInfoShown = () => {
  const releases = useSelector(selectReleases);
  const { isFreeAccount } = useSubscription();

  /*
   * We need to initialize the releases even for free users for an edge case where a user is subscribed and releases,
   * but afterwards cancels his subscription. After the subscription expires, he will be a free user with releases.
   * In this case we still need to show his past releases, that's why we need to load them here.
   */
  distributionApi.useGetAllReleasesQuery(1);

  const hasReleasedPreviously = !isEmpty(releases);

  if (hasReleasedPreviously) return false;

  if (!isFreeAccount) return false;

  return true;
};
